export interface SendOTPDto
{
    getMsisdn(): string;
    getLanguage(): string;
    getClientTxnId(): string;

    getRespCode(): string;
    getRespDesc(): string;
    getSrvType(): string;
    getSecToc(): string;
}

export class SendOTPDtoImpl implements SendOTPDto
{
    private msisdn: string;
    private language: string;
    private clientTxnId: string;
    private respCode: string;
    private respDesc: string;
    private srvType: string;
    private secToc: string;

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getClientTxnId(): string 
    {
        return this.clientTxnId;
    }
    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }

    getRespCode(): string 
    {
        return this.respCode;
    }
    setRespCode(respCode: string)
    {
        this.respCode = respCode;
    }

    getRespDesc(): string 
    {
        return this.respDesc;
    }
    setRespDesc(respDesc: string)
    {
        this.respDesc = respDesc;
    }

    getSrvType(): string 
    {
        return this.srvType;
    }
    setSrvType(srvType: string)
    {
        this.srvType = srvType;
    }

    getSecToc(): string 
    {
        return this.secToc;
    }
    setSecToc(secToc: string)
    {
        this.secToc = secToc;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto.tsx